import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
export function Hero() {
  const navigate = useNavigate();
  const locations = [{
    id: 'annapolis',
    name: 'Jennifer Rd, Annapolis, MD',
    address: '2002 Jennifer Rd, Annapolis, MD 21401'
  }];
  return <section className="relative py-12 sm:py-16 lg:py-24 border-b border-slate-100 overflow-hidden" data-id="element-133" data-mp="4jm6npu5l5rm">
      {/* Background Image */}
      <motion.div initial={{
      scale: 1.1,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 1.5,
      ease: 'easeOut'
    }} className="absolute inset-0 z-0" data-id="element-134" data-mp="x9upzl0fdw7s">
        <img src="https://cdn.magicpatterns.com/uploads/qCDJanuqP7AjhZnRF6Mqoy/ChatGPT_Image_May_19,_2026,_02_27_47_AM.png" alt="Daily Care Pharmacy Storefront" className="w-full h-full object-cover" data-id="element-135" data-mp="3d21rzwjzqin7" />
        <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-[2px]" data-id="element-136" data-mp="3j925dog4jqvj"></div>
      </motion.div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-137" data-mp="3o73og9djvq70">
        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.2,
        duration: 0.8
      }} className="text-center mb-12 sm:mb-16 bg-slate-900/20 backdrop-blur-md py-10 px-6 rounded-3xl border border-white/10 max-w-3xl mx-auto" data-id="element-138" data-mp="399bavmrkdbvg">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-white tracking-tight mb-4 drop-shadow-xl" data-id="element-139" data-mp="2qleoaje2bidn">
            Welcome to Your Local Pharmacy.
          </h1>
          <p className="text-white text-base sm:text-lg font-medium drop-shadow-md" data-id="element-140" data-mp="2hk84o1g49rg6">
            Visit us in Annapolis for all your healthcare needs.
          </p>
        </motion.div>

        <div className="max-w-md mx-auto" data-id="element-141" data-mp="s2jp22e1eam5">
          {locations.map((loc, idx) => <motion.div key={idx} initial={{
          y: 30,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.4 + idx * 0.1,
          duration: 0.6
        }} className="bg-white border-2 border-slate-100 rounded-xl p-6 sm:p-8 hover:border-clinical-blue transition-all group text-center" data-id="element-142" data-mp="nbl2wm6daiaz" data-mpi={idx}>
              <div className="flex flex-col items-center gap-3 mb-6" data-id="element-143" data-mp="1126owjr4b8d3">
                <div className="w-12 h-12 bg-clinical-blue/5 rounded-full flex items-center justify-center text-clinical-blue mb-2" data-id="element-144" data-mp="114kkctppmml6">
                  <MapPinIcon className="w-6 h-6" data-id="element-145" data-mp="3ltgojuoc2yqg" />
                </div>
                <h3 className="text-xl font-black text-slate-900 uppercase tracking-tight" data-id="element-146" data-mp="3hrd80rmt53yb">{loc.name}</h3>
              </div>
              <p className="text-slate-500 text-sm mb-8 leading-relaxed" data-id="element-147" data-mp="1x9uk28qzz9md">
                {loc.address}
              </p>
              <button onClick={() => navigate(`/otc-products/${loc.id}`)} className="w-full bg-clinical-blue text-white font-black py-4 rounded-lg hover:bg-blue-700 transition-colors uppercase tracking-widest text-xs shadow-lg shadow-clinical-blue/20" data-id="element-148" data-mp="21bplrecubp0o">
                Shop OTC Products
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}